import { Datum } from '../../interfaces';
import { API_KEYS } from '../../interfaces/api';
import { showModal, hideModal } from '../slices/modal';
import { show } from '../slices/notification';
import { apiRequestReplaceResponse } from '../slices/requestSlice';
import { history } from '../store';
import {
  apiThunk,
  apiTickectmanThunk,
  apiAlphaThunk,
  logOut,
  resetApiThunk,
} from './api';
import {
  ADD_USERPIN_REQUEST,
  ALPHA_LOGIN_REQUEST,
  CHANGE_PASSWORD_URLPARAMS,
  CHANGE_PIN_REQUEST,
  LOGIN_VALUES,
  PROFILE_INTL_USER_REQUEST,
  PROFILE_VALUES,
  REQUEST_OTP_REQUEST,
  RESET_USERPIN_REQUEST,
  SIGNUP_VALUES,
  TICKENTMAN_TOKEN,
  VERIFY_OTP_REQUEST,
} from './interfaces/auth.interface';
import {
  DATE_FILTER,
  RATING_REQUEST,
  Report_Issues,
} from './interfaces/common.interface';
import {
  CREATE_DROPOFF_REQUEST,
  CREATE_INTL_SHIPMENT_REQUEST,
  DROPOFF_REQUEST,
  GET_INTL_PRICE_REQUEST,
  GET_PRICE_REQUEST,
  HANDLE_SHIPMENT_REQUEST,
  HAULAGE_PRICE_REQUEST,
  SHIPMENT_REQUEST,
  SHIPPING_QUOTE_REQUEST,
  WAYBILL_PAYMENT_LOG_REQUEST,
  CELLULANT_ENCRYPTION_REQUEST,
  CURRENCY_EQUIVALENT,
  GET_INTL_QUOTE_REQUEST,
} from './interfaces/shipping.interface';
import { Thunk } from './interfaces/thunks.interface';
import {
  WALLET_HISTORY,
  WALLET_PAYMENT_LOG_REQUEST,
} from './interfaces/wallet.interface';

import {
  CUSTOMER_VALIDATION_DATA,
  CHARGE_WALLET_DATA,
  SEND_PAY_ADVICE_DATA,
  BILL_REFERENCE_DATA,
  VERIFY_PIN,
  VALIDATE_BILLS_DATA,
} from './interfaces/billspayment.interface';

import {
  WITHDRAW_COD_DATA,
  VALIDATE_BANK_DATA,
  COD_HISTORY_DATA,
  VALIDATE_BVN_DATA,
  CREATE_STELLAS_DATA,
} from './interfaces/cod.interface';

import { WALLETPIN_OTP_DATA } from './interfaces/walletpin.interface';

import { ALPHA_SHIPPING_PRICE } from './interfaces/alpha.interface';

export const thunks: Thunk = {
  GET_CATEGORIES_BY_COUNTRY: (
    destinationCountryId: string,
    departureCountryId: string
  ) =>
    apiThunk({
      key: API_KEYS.GET_CATEGORIES_BY_COUNTRY,
      request: { destinationCountryId, departureCountryId },
      showSuccessAlert: false,
      showErrorAlert: false,
      apiOptions: {},
      urlParams: {
        destinationCountryId,
        departureCountryId,
      },
    }),
  LOGIN: (request: Partial<LOGIN_VALUES>) =>
    apiThunk<Partial<LOGIN_VALUES>>({
      key: API_KEYS.LOGIN,
      request: { UserDetail: request.UserDetail },
      showSuccessAlert: false,
      onSuccessCallback: (req, res) => {
        if (res?.data?.Object && !res?.data?.Object?.IsActive) {
          history.push('/verify-otp');
        }
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.data?.Object && !res?.data?.Object?.IsActive) {
          dispatch(
            show({
              alertType: 'info',
              message: 'Kindly verify your OTP',
            })
          );
        }
      },
      apiOptions: {
        data: request,
      },
    }),
  SIGN_UP: (request: SIGNUP_VALUES) =>
    apiThunk<SIGNUP_VALUES>({
      key: API_KEYS.SIGN_UP,
      request,
      successAlertMessage: 'Sign up successful',
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.data?.Object?.PhoneSent || res?.data?.Object?.EmailSent) {
          dispatch(
            thunks.LOGIN({
              UserDetail: req.Email,
              Password: req.Password,
              UserChannelType: '',
            })
          );
          dispatch(resetApiThunk(API_KEYS.SIGN_UP));
        }
      },
      apiOptions: {
        data: request,
      },
    }),
  EDIT_PROFILE: (request: PROFILE_VALUES) =>
    apiThunk<PROFILE_VALUES>({
      key: API_KEYS.EDIT_PROFILE,
      request,
      successAlertMessage: 'Profile updated successfully',
      apiOptions: {
        data: request,
      },
    }),
  FORGOT_PASSWORD: (request: Pick<PROFILE_VALUES, 'Email'>) =>
    apiThunk<Pick<PROFILE_VALUES, 'Email'>>({
      key: API_KEYS.FORGOT_PASSWORD,
      successAlertMessage:
        'Your request has been received, please check your email for further instructions',
      request,
      apiOptions: {
        data: request,
      },
    }),
  CHANGE_PASSWORD: (request: CHANGE_PASSWORD_URLPARAMS) =>
    apiThunk<CHANGE_PASSWORD_URLPARAMS>({
      key: API_KEYS.CHANGE_PASSWORD,
      request,
      // successAlertMessage: 'Password has been changed successfully',
      dispatchOnSuccess: (dispatch) => {
        dispatch(logOut());
        dispatch(
          show({
            alertType: 'success',
            message: 'Password has been changed successfully',
          })
        );
      },
      apiOptions: {
        data: {},
      },
      urlParams: request as unknown as Datum,
    }),

  GET_WALLET_BALANCE: () =>
    apiThunk({
      key: API_KEYS.GET_WALLET_BALANCE,
      request: {},
      showSuccessAlert: false,
      apiOptions: {},
    }),

  GET_STATIONS: () =>
    apiThunk({
      key: API_KEYS.GET_STATIONS,
      showSuccessAlert: false,
      showErrorAlert: false,
      request: {},
      apiOptions: {},
    }),

  GET_ITEM_TYPES: () =>
    apiThunk({
      key: API_KEYS.GET_ITEM_TYPES,
      request: {},
      apiOptions: {},
    }),

  GET_ACTIVE_LGAS: () =>
    apiThunk({
      key: API_KEYS.GET_ACTIVE_LGAS,
      showSuccessAlert: false,
      request: {},
      apiOptions: {},
    }),

  GET_SPECIAL_PACKAGES: () =>
    apiThunk({
      key: API_KEYS.GET_SPECIAL_PACKAGES,
      showSuccessAlert: false,
      request: {},
      apiOptions: {},
    }),
  WALLET_TRANSACTIONS_SHIPMENT_HISTORY: (request: WALLET_HISTORY) =>
    apiThunk<WALLET_HISTORY>({
      key: API_KEYS.WALLET_TRANSACTIONS_SHIPMENT_HISTORY,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),
  TRACK_SHIPMENT: (waybillnumber: string) =>
    apiThunk({
      key: API_KEYS.TRACK_SHIPMENT,
      request: { waybillnumber },
      showSuccessAlert: false,
      apiOptions: {},
      urlParams: {
        waybillnumber,
      },
    }),
  GET_HAULAGE: () =>
    apiThunk({
      key: API_KEYS.GET_HAULAGE,
      request: {},
      apiOptions: {},
      showSuccessAlert: false,
    }),
  GET_HAULAGE_PRICE: (request: HAULAGE_PRICE_REQUEST) =>
    apiThunk<HAULAGE_PRICE_REQUEST>({
      key: API_KEYS.GET_HAULAGE_PRICE,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),
  GET_SHIPMENT_DETAILS: (waybillnumber: string) =>
    apiThunk({
      key: API_KEYS.GET_SHIPMENT_DETAILS,
      request: { waybillnumber },
      showSuccessAlert: false,
      apiOptions: {},
      urlParams: {
        waybillnumber,
      },
    }),

  // added
  GET_DELIVERY_MANIFEST: (manifestcode: string, waybillnumber: string) =>
    apiThunk({
      key: API_KEYS.GET_DELIVERY_MANIFEST,
      request: { manifestcode, waybillnumber },
      showSuccessAlert: false,
      apiOptions: {},
      urlParams: {
        manifestcode,
        waybillnumber,
      },
    }),

  GET_SHIPMENT_IN_DISPUTE: () =>
    apiThunk({
      key: API_KEYS.GET_SHIPMENT_IN_DISPUTE,
      request: {},
      apiOptions: {},
    }),
  GET_DROPOFF: (waybillnumber: number) =>
    apiThunk({
      key: API_KEYS.GET_DROPOFF,
      request: { waybillnumber },
      apiOptions: {},
      urlParams: {
        waybillnumber,
      },
    }),
  GET_OUTSTANDING_PAYMENTS: () =>
    apiThunk({
      key: API_KEYS.GET_OUTSTANDING_PAYMENTS,
      request: {},
      apiOptions: {},
    }),
  GET_PAYMENT_STATUS: (waybillnumber: number) =>
    apiThunk({
      key: API_KEYS.GET_PAYMENT_STATUS,
      request: { waybillnumber },
      apiOptions: {},
      urlParams: {
        waybillnumber,
      },
    }),
  GET_HOME_DELIVERY_LOCATIONS: () =>
    apiThunk({
      key: API_KEYS.GET_HOME_DELIVERY_LOCATIONS,
      showSuccessAlert: false,
      request: {},
      apiOptions: {},
    }),
  GET_STATIONS_BY_COUNTRY: (countryid: string | number) =>
    apiThunk({
      key: API_KEYS.GET_STATIONS_BY_COUNTRY,
      request: { countryid },
      showSuccessAlert: false,
      apiOptions: {},
      urlParams: {
        countryid,
      },
    }),

  GET_SERVICE_CENTERS_BY_STATION: (stationid: string | number) =>
    apiThunk({
      key: API_KEYS.GET_SERVICE_CENTERS_BY_STATION,
      request: { stationid },
      showSuccessAlert: false,
      apiOptions: {},
      urlParams: {
        stationid,
      },
    }),
  GET_SERVICE_CENTERS_BY_COUNTRY: (countryid: string | number) =>
    apiThunk({
      key: API_KEYS.GET_SERVICE_CENTERS_BY_COUNTRY,
      request: { countryid },
      showSuccessAlert: false,
      apiOptions: {},
      urlParams: {
        countryid,
      },
    }),
  GET_IDENTIFICATION_TYPES: () =>
    apiThunk({
      key: API_KEYS.GET_IDENTIFICATION_TYPES,
      showSuccessAlert: false,
      request: {},
      apiOptions: {},
    }),
  GET_ACTIVE_COUNTRIES: () =>
    apiThunk({
      key: API_KEYS.GET_ACTIVE_COUNTRIES,
      request: {},
      showSuccessAlert: false,
      apiOptions: {},
    }),
  GET_SHIPMENT_MESSAGE: () =>
    apiThunk({
      key: API_KEYS.GET_SHIPMENT_MESSAGE,
      request: {},
      apiOptions: {},
    }),
  GET_NOTIFICATIONS: () =>
    apiThunk({
      key: API_KEYS.GET_NOTIFICATIONS,
      request: {},
      showSuccessAlert: false,
      showErrorAlert: false,
      apiOptions: {},
    }),
  UPDATE_NOTIFICATION: (notificationid: string | number) =>
    apiThunk({
      key: API_KEYS.UPDATE_NOTIFICATION,
      request: { notificationid },
      apiOptions: {},
      showSuccessAlert: false,
      urlParams: {
        notificationid,
      },
    }),
  GET_STORES_BY_COUNTRY: (countryid: string | number) =>
    apiThunk({
      key: API_KEYS.GET_STORES_BY_COUNTRY,
      request: { countryid },
      apiOptions: {},
      showSuccessAlert: false,
      urlParams: {
        countryid,
      },
    }),
  GET_INTERNATIONAL_SHIPMENTS: () =>
    apiThunk({
      key: API_KEYS.GET_INTERNATIONAL_SHIPMENTS,
      request: {},
      apiOptions: {},
    }),
  VERIFY_PAYMENT: (waybillnumber: string) =>
    apiThunk({
      key: API_KEYS.VERIFY_PAYMENT,
      request: { waybillnumber },
      successAlertMessage: 'Wallet funded successfully',
      dispatchOnSuccess: (dispatch, req, res) => {
        dispatch(hideModal());
        dispatch(thunks.GET_WALLET_BALANCE());
        dispatch(
          thunks.WALLET_TRANSACTIONS_SHIPMENT_HISTORY({
            StartDate: null,
            EndDate: null,
          })
        );
      },
      apiOptions: {},
      urlParams: {
        waybillnumber,
      },
    }),
  REPORT_ISSUES: (request: Report_Issues) =>
    apiThunk<Report_Issues>({
      key: API_KEYS.REPORT_ISSUES,
      request,
      successAlertMessage: 'Issue has been reported successfully',
      dispatchOnSuccess: (dispatch, req, res) => {
        history.push('/');
        dispatch(resetApiThunk(API_KEYS.REPORT_ISSUES));
      },
      apiOptions: {
        data: request,
      },
    }),
  GET_PRICE: (request: GET_PRICE_REQUEST) =>
    apiThunk<GET_PRICE_REQUEST>({
      key: API_KEYS.GET_PRICE,
      showSuccessAlert: false,
      request,
      apiOptions: {
        data: request,
      },
    }),
  GET_PRICE_QUOTE: (request: GET_PRICE_REQUEST) =>
    apiThunk<GET_PRICE_REQUEST>({
      key: API_KEYS.GET_PRICE_QUOTE,
      showSuccessAlert: false,
      request,
      apiOptions: {
        data: request,
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        dispatch(
          showModal({
            component: 'PriceQuoteModal',
            modalProps: {
              contentLabel: 'Shipment Quote',
            },
          })
        );
      },
    }),
  GET_INTL_PRICE: (request: GET_INTL_PRICE_REQUEST) =>
    apiThunk<GET_INTL_PRICE_REQUEST>({
      key: API_KEYS.GET_INTL_PRICE,
      showSuccessAlert: false,
      request,
      apiOptions: {
        data: request,
      },
      dispatchOnSuccess: (dispatch) => {
        dispatch(
          showModal({
            component: 'PriceQuoteModal',
            modalProps: {
              contentLabel: 'Shipment Quote',
            },
          })
        );
      },
    }),
  ADD_WAYBILL_PAYMENT_LOG: (request: WAYBILL_PAYMENT_LOG_REQUEST) =>
    apiThunk<WAYBILL_PAYMENT_LOG_REQUEST>({
      key: API_KEYS.ADD_WAYBILL_PAYMENT_LOG,
      request,
      apiOptions: {
        data: request,
      },
    }),
  CREATE_SHIPMENT: (
    request: SHIPMENT_REQUEST,
    handleShipmentRequest: HANDLE_SHIPMENT_REQUEST
  ) =>
    apiThunk<SHIPMENT_REQUEST>({
      key: API_KEYS.CREATE_SHIPMENT,
      request,
      showErrorAlert: true,
      successAlertMessage: 'Shipment created successfully',
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.data?.Object?.waybill) {
          dispatch(
            thunks.HANDLE_SHIPMENT(res.data.Object.waybill, {
              ...handleShipmentRequest,
              waybillNumber: res?.data?.Object?.waybill,
            })
          );
          history.push(`/wallet/shipments/${res.data.Object?.waybill}`);
        }
      },
      apiOptions: {
        data: request,
      },
    }),
  RESOLVE_DISPUTE: () =>
    apiThunk({
      key: API_KEYS.RESOLVE_DISPUTE,
      request: {},
      apiOptions: {},
    }),
  CANCEL_SHIPMENT: (waybillnumber: string) =>
    apiThunk({
      key: API_KEYS.CANCEL_SHIPMENT,
      request: { waybillnumber },
      successAlertMessage: 'Shipment cancelled successfully',
      apiOptions: {},
      dispatchOnSuccess: (dispatch, req, res) => {
        dispatch(thunks.DELETE_SHIPMENT(waybillnumber));
        dispatch(thunks.GET_WALLET_BALANCE());
        dispatch(
          thunks.WALLET_TRANSACTIONS_SHIPMENT_HISTORY({
            StartDate: null,
            EndDate: null,
          })
        );
        dispatch(resetApiThunk(API_KEYS.CANCEL_SHIPMENT));
      },
      urlParams: {
        waybillnumber,
      },
    }),
  CANCEL_SHIPMENT_NOCHARGE: (waybillnumber: string) =>
    apiThunk({
      key: API_KEYS.CANCEL_SHIPMENT_NOCHARGE,
      request: { waybillnumber },
      successAlertMessage: 'Shipment cancelled successfully',
      dispatchOnSuccess: (dispatch, req, res) => {
        dispatch(thunks.DELETE_SHIPMENT(waybillnumber));
        dispatch(thunks.GET_WALLET_BALANCE());
        dispatch(
          thunks.WALLET_TRANSACTIONS_SHIPMENT_HISTORY({
            StartDate: null,
            EndDate: null,
          })
        );
        dispatch(resetApiThunk(API_KEYS.CANCEL_SHIPMENT_NOCHARGE));
      },
      apiOptions: {
        data: { waybill: waybillnumber },
      },
    }),
  ADD_WALLET_PAYMENT_LOG: (request: WALLET_PAYMENT_LOG_REQUEST) =>
    apiThunk<WALLET_PAYMENT_LOG_REQUEST>({
      key: API_KEYS.ADD_WALLET_PAYMENT_LOG,
      showSuccessAlert: false,
      request,
      apiOptions: {
        data: request,
      },
    }),
  ADD_RATING: (request: RATING_REQUEST) =>
    apiThunk<RATING_REQUEST>({
      key: API_KEYS.ADD_RATING,
      request,
      showErrorAlert: false,
      apiOptions: {
        data: request,
      },
    }),
  VERIFY_OTP: (request: VERIFY_OTP_REQUEST) =>
    apiThunk<VERIFY_OTP_REQUEST>({
      key: API_KEYS.VERIFY_OTP,
      request,
      successAlertMessage: 'Account succesfully verified',
      dispatchOnSuccess: (dispatch, req, res) => {
        dispatch(
          apiRequestReplaceResponse({
            key: API_KEYS.LOGIN,
            response: res?.data,
          })
        );
        history.push('/');
        dispatch(resetApiThunk(API_KEYS.VERIFY_OTP));
      },
      apiOptions: {
        data: request,
      },
    }),
  RESEND_OTP: (request: REQUEST_OTP_REQUEST) =>
    apiThunk<REQUEST_OTP_REQUEST>({
      key: API_KEYS.RESEND_OTP,
      showSuccessAlert: false,
      request,
      apiOptions: {
        data: request,
      },
    }),
  GET_DROPOFF_PRICE: (request: DROPOFF_REQUEST) =>
    apiThunk<DROPOFF_REQUEST>({
      key: API_KEYS.GET_DROPOFF_PRICE,
      showSuccessAlert: false,
      request,
      apiOptions: {
        data: request,
      },
    }),
  CREATE_DROPOFF: (request: CREATE_DROPOFF_REQUEST) =>
    apiThunk<CREATE_DROPOFF_REQUEST>({
      key: API_KEYS.CREATE_DROPOFF,
      request,
      apiOptions: {
        data: request,
      },
      successAlertMessage: 'Drop-Off created successfully',
      onSuccessCallback: (req, res) => {
        if (res?.data?.Code === '200' && res?.data?.Object) {
          history.push('/dropoff/manage');
        }
      },
    }),
  CANCEL_DROPOFF: (tempcode: string) =>
    apiThunk({
      key: API_KEYS.CANCEL_DROPOFF,
      request: { tempcode },
      successAlertMessage: 'Drop-Off Cancelled Successfully',
      dispatchOnSuccess: (dispatch) => {
        dispatch(
          thunks.GET_DROP_OFF_LIST({
            StartDate: null,
            EndDate: null,
          })
        );
      },
      apiOptions: {},
      urlParams: {
        tempcode,
      },
    }),
  INTL_SHIPMENT_REQUEST_LIST: (request: DATE_FILTER) =>
    apiThunk<DATE_FILTER>({
      key: API_KEYS.INTL_SHIPMENT_REQUEST_LIST,
      showSuccessAlert: false,
      request,
      apiOptions: {
        data: request,
      },
    }),
  GET_DROP_OFF_LIST: (request: DATE_FILTER) =>
    apiThunk<DATE_FILTER>({
      key: API_KEYS.GET_DROP_OFF_LIST,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),
  CREATE_INTL_SHIPMENT_REQUEST: (request: CREATE_INTL_SHIPMENT_REQUEST) =>
    apiThunk<CREATE_INTL_SHIPMENT_REQUEST>({
      key: API_KEYS.CREATE_INTL_SHIPMENT_REQUEST,
      request,
      successAlertMessage: 'International shipment created successfully',
      dispatchOnSuccess: (dispatch) => {
        dispatch(
          showModal({
            modalProps: {
              contentLabel: 'Global shipping confirmation',
            },
            component: 'Confirmation',
          })
        );
      },
      apiOptions: {
        data: request,
      },
    }),
  EDIT_INTL_SHIPMENT_REQUEST: (
    requestnumber: string,
    request: Partial<CREATE_INTL_SHIPMENT_REQUEST>
  ) =>
    apiThunk({
      key: API_KEYS.EDIT_INTL_SHIPMENT_REQUEST,
      request: { requestnumber, request },
      dispatchOnSuccess: (dispatch, req, res) => {
        dispatch(
          thunks.INTL_SHIPMENT_REQUEST_LIST({
            StartDate: null,
            EndDate: null,
          })
        );
      },
      apiOptions: {
        data: request,
      },
      urlParams: {
        requestnumber,
      },
    }),
  GET_INTL_SHIPMENT_MESSAGE: (countryid: number) =>
    apiThunk({
      key: API_KEYS.GET_INTL_SHIPMENT_MESSAGE,
      showSuccessAlert: false,
      request: { countryid },
      apiOptions: {
        params: {
          countryid,
        },
      },
    }),
  PROFILE_INTL_USER: (request: PROFILE_INTL_USER_REQUEST) =>
    apiThunk<PROFILE_INTL_USER_REQUEST>({
      key: API_KEYS.PROFILE_INTL_USER,
      request,
      successAlertMessage: 'ID Uploaded successfully',
      apiOptions: {
        data: request,
      },
    }),
  GET_VEHICLE_STATUS: () =>
    apiThunk({
      key: API_KEYS.GET_VEHICLE_STATUS,
      request: {},
      apiOptions: {},
      showSuccessAlert: false,
    }),

  UPLOAD_IMAGE: (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    const url = URL.createObjectURL(file);
    return apiThunk({
      key: API_KEYS.UPLOAD_IMAGE,
      request: { name: file.name, url },
      successAlertMessage: 'File uploaded successfully',
      showSuccessAlert: false,
      showErrorAlert: false,
      apiOptions: {
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    });
  },
  HANDLE_SHIPMENT: (waybillnumber: string, request: HANDLE_SHIPMENT_REQUEST) =>
    apiThunk({
      key: API_KEYS.HANDLE_SHIPMENT,
      request: { waybillnumber, request },
      successAlertMessage: 'Your shipment has been sent for processing',
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
      urlParams: {
        waybillnumber,
      },
    }),
  GET_PARTNER_DETAILS: (waybillnumber: string) =>
    apiThunk({
      key: API_KEYS.GET_PARTNER_DETAILS,
      showSuccessAlert: false,
      request: { waybillnumber },
      apiOptions: {},
      urlParams: {
        waybillnumber,
      },
    }),

  DELETE_SHIPMENT: (waybillnumber: string) =>
    apiThunk({
      key: API_KEYS.DELETE_SHIPMENT,
      request: { waybillnumber },
      showSuccessAlert: false,
      showErrorAlert: false,
      successAlertMessage: 'Shipment removed from Queue',
      apiOptions: {},
      urlParams: {
        waybillnumber,
      },
    }),
  REQUEST_QUOTE: (request: SHIPPING_QUOTE_REQUEST) =>
    apiThunk<SHIPPING_QUOTE_REQUEST>({
      key: API_KEYS.REQUEST_QUOTE,
      request,
      apiOptions: {
        data: request,
      },
    }),

  VERIFY_USER_PIN: (request: VERIFY_PIN) =>
    apiThunk<VERIFY_PIN>({
      key: API_KEYS.VERIFY_USER_PIN,
      request,
      showSuccessAlert: false,
      showErrorAlert: true,
      apiOptions: {
        data: request,
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.data?.Object === false) {
          dispatch(
            show({
              alertType: 'error',
              message: 'Incorrect Pin',
            })
          );
        }
      },
    }),

  CHARGE_WALLET: (request: CHARGE_WALLET_DATA) =>
    apiThunk<CHARGE_WALLET_DATA>({
      key: API_KEYS.CHARGE_WALLET,
      request,
      showSuccessAlert: false,
      showErrorAlert: true,
      apiOptions: {
        data: request,
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        if (
          res?.data?.Object?.Message ===
          'Insufficient balance on customer wallet'
        ) {
          dispatch(
            show({
              alertType: 'error',
              message: res?.data?.Object?.Message,
            })
          );
        }
      },
    }),

  TICKETMAN_ACCESSTOKEN: (request: TICKENTMAN_TOKEN, token: string) =>
    apiThunk<TICKENTMAN_TOKEN>({
      key: API_KEYS.TICKETMAN_ACCESSTOKEN,
      request,
      apiOptions: {
        data: `grant_type=password&username=it@giglogistics.com&password=${process.env.REACT_APP_TICKETMAN_PASSWORD}`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
      showSuccessAlert: false,
      showErrorAlert: true,
    }),

  GET_BILLS_CATEGORY: (CategoryId: number) =>
    apiTickectmanThunk({
      key: API_KEYS.GET_BILLS_CATEGORY,
      request: { CategoryId },
      apiOptions: {},
      urlParams: {
        CategoryId,
      },
      showSuccessAlert: false,
    }),
  GET_BILLERS_BY_CATEGORY: (CategoryId: number) =>
    apiTickectmanThunk({
      key: API_KEYS.GET_BILLERS_BY_CATEGORY,
      request: { CategoryId },
      showSuccessAlert: false,
      apiOptions: {
        params: {
          CategoryId,
        },
      },
    }),
  GET_BILLER_PAYMENT_ITEMS: (billerId: number) =>
    apiTickectmanThunk({
      key: API_KEYS.GET_BILLER_PAYMENT_ITEMS,
      request: { billerId },
      apiOptions: {
        params: {
          billerId,
        },
      },
      showSuccessAlert: false,
    }),
  CUSTOMER_VALIDATION: (request: CUSTOMER_VALIDATION_DATA) =>
    apiTickectmanThunk<CUSTOMER_VALIDATION_DATA>({
      key: API_KEYS.CUSTOMER_VALIDATION,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
      showErrorAlert: true,
      // onSuccessCallback: (req, res) => {
      //   if (res?.status == 200) {
      //     history.push('/bill-summary');
      //   }
      // },
    }),

  GET_PAYMENT_REFERENCE: (request: BILL_REFERENCE_DATA) =>
    apiTickectmanThunk<BILL_REFERENCE_DATA>({
      key: API_KEYS.GET_PAYMENT_REFERENCE,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),

  SEND_PAY_ADVICE: (request: SEND_PAY_ADVICE_DATA) =>
    apiTickectmanThunk<SEND_PAY_ADVICE_DATA>({
      key: API_KEYS.SEND_PAY_ADVICE,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
      showErrorAlert: true,
      // dispatchOnSuccess: (dispatch, req, res) => {
      //   if(res?.code == 200 && res?.payload?.pushNotificationMSG){
      //     dispatch(
      //       show({
      //         alertType: 'success',
      //         message: res?.payload.pushNotificationMSG,
      //       })
      //     );
      //   }
      // },
    }),

  VALIDATE_PHONENUMBER: (phone: number) =>
    apiThunk({
      key: API_KEYS.VALIDATE_PHONENUMBER,
      request: { phone },
      showSuccessAlert: false,
      apiOptions: {
        params: {
          phone,
        },
      },
    }),

  GET_WALLETPIN_STATUS: () =>
    apiThunk({
      key: API_KEYS.GET_WALLETPIN_STATUS,
      request: {},
      apiOptions: {},
      showSuccessAlert: false,
    }),

  ADD_USER_PIN: (request: ADD_USERPIN_REQUEST) =>
    apiThunk({
      key: API_KEYS.ADD_USER_PIN,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
    }),
  CHANGE_USER_PIN: (request: CHANGE_PIN_REQUEST) =>
    apiThunk({
      key: API_KEYS.CHANGE_USER_PIN,
      request: {},
      apiOptions: {
        data: request,
      },
    }),

  RESET_WALLET_PIN: (request: RESET_USERPIN_REQUEST) =>
    apiThunk({
      key: API_KEYS.RESET_WALLET_PIN,
      request: {},
      apiOptions: {
        data: request,
      },
    }),
  WALLETPIN_VERIFY_OTP: (request: WALLETPIN_OTP_DATA) =>
    apiThunk<WALLETPIN_OTP_DATA>({
      key: API_KEYS.WALLETPIN_VERIFY_OTP,
      showSuccessAlert: true,
      request,
      apiOptions: {
        data: request,
      },
    }),

  VALIDATE_BILLS_PAYMENT: (request: VALIDATE_BILLS_DATA) =>
    apiThunk<VALIDATE_BILLS_DATA>({
      key: API_KEYS.VALIDATE_BILLS_PAYMENT,
      showSuccessAlert: false,
      showErrorAlert: true,
      request,
      apiOptions: {
        data: request,
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.data?.Code === '200') {
          dispatch(
            show({
              alertType: 'success',
              message: res?.data?.Object,
            })
          );
          history.push('/bill-summary');
        }
      },
    }),

  GET_OUTBOUND_COUNTRIES: () =>
    apiThunk({
      key: API_KEYS.GET_OUTBOUND_COUNTRIES,
      request: {},
      apiOptions: {},
      showSuccessAlert: false,
    }),

  GET_INTERNATIONAL_SHIPMENTS_RATE: (request: any) =>
    apiThunk({
      key: API_KEYS.GET_INTERNATIONAL_SHIPMENTS_RATE,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
    }),

  GET_COMPUTE_COUPON: (coup: string, total: number) =>
    apiThunk({
      key: API_KEYS.GET_COMPUTE_COUPON,
      request: { coup, total },
      apiOptions: {},
      urlParams: {
        coup,
        total,
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.data?.Code === '400') {
          dispatch(
            show({
              alertType: 'error',
              message: res?.data?.ShortDescription,
            })
          );
        }
      },
      showSuccessAlert: false,
    }),
  GET_PAYMENTMETHOD_BY_COUNTRY: (countryid: string | number) =>
    apiThunk({
      key: API_KEYS.GET_PAYMENTMETHOD_BY_COUNTRY,
      showSuccessAlert: false,
      request: { countryid },
      apiOptions: {},
      urlParams: {
        countryid,
      },
    }),
  CHECK_CELLULANT_ENCRYPTION: (request: CELLULANT_ENCRYPTION_REQUEST) =>
    apiThunk<CELLULANT_ENCRYPTION_REQUEST>({
      key: API_KEYS.CHECK_CELLULANT_ENCRYPTION,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),
  GET_CURRENCY_EQUIVALENT: (request: CURRENCY_EQUIVALENT) =>
    apiThunk<CURRENCY_EQUIVALENT>({
      key: API_KEYS.GET_CURRENCY_EQUIVALENT,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),

  GET_INTL_SHIPMENT_QUOTE: (request: GET_INTL_QUOTE_REQUEST) =>
    apiThunk<GET_INTL_QUOTE_REQUEST>({
      key: API_KEYS.GET_INTL_SHIPMENT_QUOTE,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),

  GET_ALPHA_PRODUCT: (searchTerm: string) =>
    apiAlphaThunk({
      key: API_KEYS.GET_ALPHA_PRODUCT,
      request: { searchTerm },
      showSuccessAlert: false,
      apiOptions: {
        params: {
          searchTerm,
        },
      },
    }),

  ALPHA_LOGIN: (request: ALPHA_LOGIN_REQUEST) =>
    apiThunk<ALPHA_LOGIN_REQUEST>({
      key: API_KEYS.ALPHA_LOGIN,
      request,
      apiOptions: {
        data: {
          email: 'it@giglogistics.com',
          password: 'agility',
          user_type: 'user',
        },
        headers: {
          'Content-Type': 'application/json',
        },
      },
      showSuccessAlert: false,
      showErrorAlert: true,
    }),

  GET_ALPHA_STATIONS: () =>
    apiAlphaThunk({
      key: API_KEYS.GET_ALPHA_STATIONS,
      request: {},
      apiOptions: {},
      showSuccessAlert: false,
    }),

  WITHDRAW_COD: (request: WITHDRAW_COD_DATA) =>
    apiThunk<WITHDRAW_COD_DATA>({
      key: API_KEYS.WITHDRAW_COD,
      showErrorAlert: true,
      showSuccessAlert: false,
      request,
      apiOptions: {
        data: request,
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.data?.Object?.status === false) {
          dispatch(
            show({
              alertType: 'error',
              message: 'Unable to make transfer!! Insufficient Funds',
            })
          );
        }
      },
    }),

  VALIDATE_BANK: (request: VALIDATE_BANK_DATA) =>
    apiThunk<VALIDATE_BANK_DATA>({
      key: API_KEYS.VALIDATE_BANK,
      showSuccessAlert: false,
      request,
      apiOptions: {
        data: request,
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.data?.Object?.status === false) {
          dispatch(
            show({
              alertType: 'error',
              message:
                'BVN data mis-match. Please ensure the details on your profile match the details on your BVN',
            })
          );
        }
      },
    }),
  GET_COD_BANKS: () =>
    apiThunk({
      key: API_KEYS.GET_COD_BANKS,
      request: {},
      apiOptions: {},
      showSuccessAlert: false,
    }),

  GET_ACTIVE_ALPHA_LOCATIONS: (request: any) =>
    apiAlphaThunk({
      key: API_KEYS.GET_ACTIVE_ALPHA_LOCATIONS,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
    }),

  GET_ALPHA_HOMEDELIVERY: (request: any) =>
    apiAlphaThunk({
      key: API_KEYS.GET_ALPHA_HOMEDELIVERY,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
    }),
  GET_ALPHA_PAYMENT_METHODS: (request: any) =>
    apiAlphaThunk({
      key: API_KEYS.GET_ALPHA_PAYMENT_METHODS,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
    }),
  GET_ALPHA_SERVICE_CENTERS: (stationId: string | number) =>
    apiAlphaThunk({
      key: API_KEYS.GET_ALPHA_SERVICE_CENTERS,
      showSuccessAlert: false,
      request: { stationId },
      apiOptions: {},
      urlParams: {
        stationId,
      },
    }),

  GET_ALPHA_PRICE: (request: ALPHA_SHIPPING_PRICE) =>
    apiAlphaThunk<ALPHA_SHIPPING_PRICE>({
      key: API_KEYS.GET_ALPHA_PRICE,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),

  GET_COD_HISTORY: (request: COD_HISTORY_DATA) =>
    apiThunk<COD_HISTORY_DATA>({
      key: API_KEYS.GET_COD_HISTORY,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
      showErrorAlert: false,
    }),
  CHECK_USER_COD_EXIST: (userchannelcode: string) =>
    apiThunk({
      key: API_KEYS.CHECK_USER_COD_EXIST,
      request: { userchannelcode },
      apiOptions: {},
      urlParams: {
        userchannelcode,
      },
      showSuccessAlert: false,
    }),

  CREATE_STELLAS_ACCOUNT: (request: CREATE_STELLAS_DATA) =>
    apiThunk<CREATE_STELLAS_DATA>({
      key: API_KEYS.CREATE_STELLAS_ACCOUNT,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: true,
      showErrorAlert: true,
    }),

  CHECK_BVN_EXIST: (bvn: string) =>
    apiThunk({
      key: API_KEYS.CHECK_BVN_EXIST,
      request: { bvn },
      apiOptions: {},
      urlParams: {
        bvn,
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.status === 200) {
          dispatch(
            show({
              alertType: 'success',
              message: res?.data?.data?.message,
            })
          );
        }
      },
      showSuccessAlert: false,
      errorAlertMessage:
        'The given BVN is already in use, pls provide another BVN',
      showErrorAlert: true,
    }),

  VALIDATE_BVN: (request: VALIDATE_BVN_DATA) =>
    apiThunk<VALIDATE_BVN_DATA>({
      key: API_KEYS.VALIDATE_BVN,
      request,
      apiOptions: {
        data: request,
      },
      dispatchOnSuccess: (dispatch, req, res) => {
        if (res?.data?.Object?.status === false) {
          dispatch(
            show({
              alertType: 'error',
              message:
                'BVN data mis-match. Please ensure the details on your profile match the details on your BVN',
            })
          );
        }
      },
      showSuccessAlert: false,
    }),
  GET_STELLAS_DETAILS: (userchannelcode: string) =>
    apiThunk({
      key: API_KEYS.GET_STELLAS_DETAILS,
      request: { userchannelcode },
      apiOptions: {},
      urlParams: {
        userchannelcode,
      },
      showSuccessAlert: false,
    }),

  GET_COD_ACCOUNT_STATEMENT: (request: any) =>
    apiThunk({
      key: API_KEYS.GET_COD_ACCOUNT_STATEMENT,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
    }),
  GET_PERSONAL_SHOPPING_LIST: () =>
    apiThunk({
      key: API_KEYS.GET_PERSONAL_SHOPPING_LIST,
      request: {},
      showSuccessAlert: false,
      apiOptions: {},
    }),
  GET_PERSONAL_SHOPPING_RECEIVER: () =>
    apiThunk({
      key: API_KEYS.GET_PERSONAL_SHOPPING_RECEIVER,
      request: {},
      showErrorAlert: false,
      showSuccessAlert: false,
      apiOptions: {},
    }),
  GET_PERSONALSHOPPING_INVOICE: (request: any) =>
    apiThunk({
      key: API_KEYS.GET_PERSONAL_SHOPPING_INVOICE,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
    }),
  CREATE_PERSONAL_SHOPPING_ITEM: (request: any) =>
    apiThunk({
      key: API_KEYS.CREATE_PERSONAL_SHOPPING_ITEM,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),
  UPDATE_PERSONAL_SHOPPING_ITEM: (id: string | number, request: any) =>
    apiThunk({
      key: API_KEYS.UPDATE_PERSONAL_SHOPPING_ITEM,
      request: { id },
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
      urlParams: {
        id,
      },
    }),
  CHARGE_PERSONAL_SHOPPING_WALLET: (request: any) =>
    apiThunk({
      key: API_KEYS.CHARGE_PERSONAL_SHOPPING_WALLET,
      request,
      apiOptions: {
        data: request,
      },
      showSuccessAlert: false,
    }),
  DELETE_PERSONAL_SHOPPING_ITEM: (id: string) =>
    apiThunk({
      key: API_KEYS.DELETE_PERSONAL_SHOPPING_ITEM,
      request: { id },
      showSuccessAlert: false,
      apiOptions: {},
      urlParams: {
        id,
      },
    }),
  GENERATE_CHECKOUT_URL: (request: any) =>
    apiThunk({
      key: API_KEYS.GENERATE_CHECKOUT_URL,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),
  REGISTER_FOR_PROMO: (request: any) =>
    apiThunk({
      key: API_KEYS.REGISTER_FOR_PROMO,
      request,
      showSuccessAlert: false,
      apiOptions: {
        data: request,
      },
    }),
};
